import React, { useEffect, useState } from 'react';

import { HeaderBanner } from '@components/customise/banner/headerbanner';
import Wizard from '@components/customise/wizard/wizard';

import { useVehicle } from '@hooks/usevehicle';
import { useDeviceDetect } from '@hooks/usedevicedetect';
import { useAppDispatch, useAppSelector } from '@hooks/statehooks';
import { setInitialState } from '@store/reducers/selectedoptions';
import { useInitialOptions } from '@hooks/useinitialoptions';

import Tabs from '@components/tabs/tabs';
import Tab from '@components/tabs/tab';
import Sidebar from '@components/customise/sidebar/sidebar';
import Loader from '@components/loader/loader';
import { canScroll } from '@store/reducers/layout';

import '@styles/page.scss';

import { Vehicle } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicle';

const Customise: React.FC = () => {
  const { loading, vehicleDetails } = useVehicle();
  const { isMobile } = useDeviceDetect();
  const dispatch = useAppDispatch();
  const sectionsClassName = 'hide-sections';

  const { finalisedOptions } = useAppSelector((state) => state);

  const [selectedOptionsReady, setSelectedOptionReady] =
    useState<boolean>(false);

  const syncSelectedOptions = () => {
    dispatch(
      setInitialState(
        useInitialOptions(vehicleDetails as Vehicle, finalisedOptions)
      )
    );

    setSelectedOptionReady(true);
  };

  useEffect(() => {
    document.body.classList.add(sectionsClassName);
    window.scrollTo(0, 0);
    dispatch(canScroll(false));
    if (!loading) {
      syncSelectedOptions();
    }

    const removeHideSections = () => {
      document.body.classList.remove(sectionsClassName);
      dispatch(canScroll(true));
    };

    return removeHideSections;
  }, [loading]);

  const renderMobile = () => {
    return (
      <div className="wrapper__tabs">
        <Tabs name="customise">
          <Tab title="Available Options" className="wizard">
            <Wizard />
          </Tab>
          <Tab title="Selected Options">
            <Sidebar />
          </Tab>
        </Tabs>
      </div>
    );
  };
  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="page">
          <div className="page-customise">
            <div className="page-customise__banner">
              <HeaderBanner {...(vehicleDetails as Vehicle)} />
            </div>
            <div className="page-customise__configuration wide-component-container">
              {selectedOptionsReady && (isMobile ? renderMobile() : <Wizard />)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Customise;
